import { render, staticRenderFns } from "./DeviceDialog.vue?vue&type=template&id=670c5f14"
import script from "./DeviceDialog.vue?vue&type=script&lang=js"
export * from "./DeviceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports